const defaultState = {
  isFetching: false,
  filesList: [],
  selectedFileId: null,
  forceUpdate: false,
  error: null,
  modalOpen: false,
  showSuccesfullUpdateSnackBar: false,
  showErrorSnackbar: false,
};

function firmwareUpdateDialog(state = defaultState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return defaultState;
    case 'FIRMWARE_CLEAR_STATE':
      return defaultState;
    case 'FIRMWARE_UPDATE_TOGGLE_SNACKBAR':
      return { ...state, showSuccesfullUpdateSnackBar: action.flag };
    case 'TOGGLE_ERROR_SNACKBAR':
      return { ...state, showErrorSnackbar: action.flag };
    case 'FIRMWARE_UPDATE_ERROR_TOGGLE_SNACKBAR':
      return { ...state, showSuccesfullUpdateSnackBar: action.flag };
    case 'FIRMWARE_RESET_DATA':
      return { ...defaultState, modalOpen: state.modalOpen };
    case 'SET_FILES':
      return { ...state, filesList: action.files };
    case 'TOGGLE_FIRMWARE_UPDATE_MODAL':
      return { ...state, modalOpen: action.open };
    case 'SET_ERROR':
      return { ...state, error: action.text };
    case 'TOGGLE_FETCH':
      return { ...state, isFetching: action.flag };
    case 'SELECT_FILE':
      return { ...state, selectedFileId: action.id };
    case 'SET_FORCE_UPDATE':
      return { ...state, forceUpdate: action.forceUpdate };
    default:
      return state;
  }
}

export default firmwareUpdateDialog;
